import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { MapPin, DollarSign, Clock } from 'lucide-react';
import { mockJobs } from '../mock';

const Jobs = ({ t, currentLang }) => {
  const getJobTitle = (job) => {
    if (currentLang === 'de') return job.titleDe;
    if (currentLang === 'sq') return job.titleSq;
    return job.title;
  };

  return (
    <section id="jobs" className="relative py-24 px-4 bg-gradient-to-b from-black via-gray-900 to-black overflow-hidden">
      {/* Background elements */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/4 right-0 w-80 h-80 bg-gradient-to-bl from-red-600/20 to-transparent rounded-full blur-3xl"></div>
        <div className="absolute bottom-1/4 left-0 w-80 h-80 bg-gradient-to-tr from-orange-600/15 to-transparent rounded-full blur-3xl"></div>
      </div>
      <div className="container mx-auto relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-red-950/50 text-orange-400 rounded-full text-sm font-semibold mb-4 border border-red-900/30">
            {t.nav.jobs}
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            {t.jobs.title}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            Explore current job opportunities in Germany with competitive salaries
          </p>
        </div>

        {/* Jobs Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {mockJobs.map((job) => (
            <Card key={job.id} className="bg-gradient-to-br from-gray-900 to-black border border-red-900/20 hover:border-orange-600/50 hover:shadow-xl hover:shadow-red-900/20 transition-all duration-300 group">
              <CardHeader>
                <div className="flex justify-between items-start mb-2">
                  <Badge className="bg-red-950/50 text-orange-400 hover:bg-red-950/50 border border-red-900/30">
                    {job.type}
                  </Badge>
                </div>
                <CardTitle className="text-xl text-white group-hover:text-orange-400 transition-colors">
                  {getJobTitle(job)}
                </CardTitle>
              </CardHeader>
              <CardContent className="space-y-4">
                <p className="text-gray-400 text-sm">
                  {job.description}
                </p>
                
                <div className="space-y-2 text-sm">
                  <div className="flex items-center gap-2 text-gray-300">
                    <MapPin className="h-4 w-4 text-orange-500" />
                    <span>{job.location}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <DollarSign className="h-4 w-4 text-orange-500" />
                    <span className="font-semibold text-orange-400">{job.salary}</span>
                  </div>
                  <div className="flex items-center gap-2 text-gray-300">
                    <Clock className="h-4 w-4 text-orange-500" />
                    <span>{job.type}</span>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Jobs;
